<mat-dialog-content class="">
  <h3 class="mb-3"><i class="fas fa-check-circle mr-1"></i> View Details</h3>

  <div class="row p-4">

    <!-- <div class="col-12 col-sm-6 row">
      <p class="col-4">Payload ID:</p> <p *ngIf="pastActionObject.payloadId; else notAvailable" class="col-8">{{pastActionObject.payloadId}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>
    <div class="col-12 col-sm-6 row">
      <p class="col-4">Camera ID:</p> <p *ngIf="pastActionObject.cameraIdentifier; else notAvailable" class="col-8">{{pastActionObject.cameraIdentifier}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>

    <hr class="col-12 hrstyle"/>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Event Type:</p> <p *ngIf="pastActionObject.eventType; else notAvailable" class="col-8">{{pastActionObject.eventType}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>
    <div class="col-12 col-sm-6 row">
      <p class="col-4">License Number:</p> <p *ngIf="pastActionObject.licenceNumber; else notAvailable" class="col-8">{{pastActionObject.licenceNumber}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>

    <hr class="col-12 hrstyle"/> -->

    <!-- <div class="col-12 col-sm-6 row">
      <p class="col-4">Date:</p> <p *ngIf="pastActionObject.date; else notAvailable" class="col-8">{{pastActionObject.date | date:'mediumDate'}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>
    <div class="col-12 col-sm-6 row">
      <p class="col-4">Time:</p> <p *ngIf="pastActionObject.time; else notAvailable" class="col-8">{{pastActionObject.time}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div>

    <hr class="col-12 hrstyle"/> -->

    <div class="col-12 col-sm-6 row">
      <p class="col-4">License Plate:</p> <p *ngIf="pastActionObject.licenceNumber; else notAvailable" class="col-8">{{pastActionObject.licenceNumber}}</p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Search Detail:</p>
       <p *ngIf="pastActionObject.matchedStatus; else notAvailable" class="col-8">
        <span *ngIf="pastActionObject.matchedStatus == 'Not matched'">Not Matched</span>
        <span *ngIf="pastActionObject.matchedListType == 'Full Match' && pastActionObject.matchedStatus == 'Hitlist'">Target Detected</span>
        <span *ngIf="pastActionObject.matchedListType == 'Partial Match' && pastActionObject.matchedStatus == 'Hitlist'">Potential Target Detected Matched with {{pastActionObject.partialMatchLicenceNumber}}</span>
       </p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>
    <!-- <div class="col-12 col-sm-6 row">
      <p class="col-4">User Name:</p> <p *ngIf="pastActionObject.userName; else notAvailable" class="col-8">{{pastActionObject.userName}}</p>
      <ng-template class="col-8" #notAvailable>N/A</ng-template>
    </div> -->

    <hr class="col-12 hrstyle"/>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">State:</p> <p *ngIf="pastActionObject.state; else notAvailable" class="col-8">{{pastActionObject.state}}</p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Camera:</p> <p *ngIf="pastActionObject.cameraIdentifier; else notAvailable" class="col-8">{{pastActionObject.cameraIdentifier}}</p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>

    <hr class="col-12 hrstyle"/>

    <div class="col-12 row col-sm-6">
      <p class="col-4">Scanned on:</p> <p *ngIf="pastActionObject.createdDate; else notAvailable" class="col-8">{{pastActionObject.createdDate | date:'long'}}</p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Job:</p> <p *ngIf="pastActionObject.job; else notAvailable" class="col-8">{{pastActionObject.job}}</p>
      <ng-template class="col-8" #notAvailable>-</ng-template>
    </div>

    <hr class="col-12 hrstyle"/>

    <span class="col-12 row" style="margin-left: -15px !important;"
                *ngIf="pastActionObject.vehicleCategory != 'OFF' &&
                 pastActionObject.vehicleMake != 'OFF' &&
                 pastActionObject.vehicleModel != 'OFF'&&
                 pastActionObject.vehicleColor != 'OFF'">

      <div class="col-12 col-sm-6 row">
        <p class="col-4">Vehicle Category:</p> <p *ngIf="pastActionObject.vehicleCategory; else notAvailable" class="col-8">{{pastActionObject.vehicleCategory}}</p>
        <ng-template class="col-8" #notAvailable>-</ng-template>
      </div>

      <div class="col-12 col-sm-6 row">
        <p class="col-4" style="margin-left: 15px !important;">Vehicle Make:</p> <p *ngIf="pastActionObject.vehicleMake; else notAvailable" class="col-7">{{pastActionObject.vehicleMake}}</p>
        <ng-template class="col-7" #notAvailable>-</ng-template>
      </div>

      <hr class="col-12 hrstyle"/>

      <div class="col-12 col-sm-6 row">
        <p class="col-4">Vehicle Model:</p> <p *ngIf="pastActionObject.vehicleModel; else notAvailable" class="col-8">{{pastActionObject.vehicleModel}}</p>
        <ng-template class="col-8" #notAvailable>-</ng-template>
      </div>

      <div class="col-12 col-sm-6 row">
        <p class="col-4" style="margin-left: 15px !important;">Vehicle Color:</p>
        <!-- <p *ngIf="pastActionObject.vehicleColor; else notAvailable" class="col-8">{{pastActionObject.vehicleColor}}</p> -->
        <span [ngStyle]="{'background-color': vehicleColor}" *ngIf="pastActionObject.vehicleColor; else notAvailable" class="colorDot"></span>
        <ng-template class="col-7" #notAvailable>-</ng-template>
      </div>

      <hr class="col-12 hrstyle"/>

    </span>

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Cropped Image:</p>
      <div *ngIf="pastActionObject.croppedImageUrl; else base64image1" class="col-8">
        <img src="{{pastActionObject.croppedImageUrl}}" width="100%" alt="License Plate Number"/>
      </div>
      <ng-template #base64image1>
        <div *ngIf="pastActionObject.image1; else notAvailableImg1" class="col-8">
          <img src="{{pastActionObject.image1}}" width="100%" alt="Car Image"/>
        </div>
      </ng-template>
      <ng-template #notAvailableImg1>
        <div class="col-8 text-center bgblue">
          <div class="spinner-overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <img
            src="assets/images/noImage.jpg"
            width="100%"
          />
        </div>
      </ng-template>
    </div>

    <!-- <hr class="col-12 hrstyle"/> -->

    <div class="col-12 col-sm-6 row">
      <p class="col-4">Full Image:</p>
      <div *ngIf="pastActionObject.fullImageUrl; else base64image2" class="col-8">
        <img src="{{pastActionObject.fullImageUrl}}" width="100%" alt="Car Image"/>
      </div>
      <ng-template #base64image2>
        <div *ngIf="pastActionObject.image2; else notAvailableImg2" class="col-8">
          <img src="{{pastActionObject.image2}}" width="100%" alt="License Plate Number"/>
        </div>
      </ng-template>
      <ng-template #notAvailableImg2>
        <div class="col-8 text-center bgblue">
          <div class="spinner-overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <img
            src="assets/images/noImage.jpg"
            width="100%"
          />
        </div>
      </ng-template>
    </div>

    <hr class="col-12 hrstyle"/>

    <div class="col-12 row">
      <p class="col-2">Location:</p>
      <agm-map class="col-10" [zoom]="18" [latitude]="pastActionObject.latitude" [longitude]="pastActionObject.longitude">
        <agm-marker [latitude]="pastActionObject.latitude" [longitude]="pastActionObject.longitude"></agm-marker>
      </agm-map>
    </div>

    <hr class="col-12 hrstyle" style="margin-top:1rem;"/>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-danger float-right" (click)="closeDialog()">
    <i class="fas fa-times mr-1"></i> Close
  </button>
</mat-dialog-actions>
